/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

// Temporary noop until TS4.1 is Released
export type Select<Model, Paths> = Model;

// type GetPathHead<T> = T extends `${infer T}.${any}` ? T : never;
// type GetPathTail<T> = T extends `${any}.${infer T}` ? T : never;

// export type Select<Model, Paths> = {
//   [
//     Index in keyof Paths as Paths[Index] extends keyof Model
//       ? Paths[Index]
//       : GetPathHead<Paths[Index]> extends keyof Model
//         ? GetPathHead<Paths[Index]>
//         : never
//   ]: Paths[Index] extends keyof Model
//     ? Model[Paths[Index]]
//     : GetPathHead<Paths[Index]> extends keyof Model
//       ? Select<Model[GetPathHead<Paths[Index]>], [GetPathTail<Paths[Index]>]>
//       : never
// };

export function intoSnakeCase(input: string): string {
  return input
    .split('.')
    .map((f) =>
      f
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        ?.map((x) => x.toLowerCase())
        .join('_'),
    )
    .join('.');
}

function intoCamelCase(str: string) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

function isDate(x: unknown): x is Date {
  return Object.prototype.toString.call(x) === '[object Date]';
}

function isRegExp(x: unknown): x is RegExp {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}

function isRecord(x: unknown): x is Record<string, unknown> {
  return typeof x === 'object' && !Array.isArray(x) && !isDate(x) && !isRegExp(x) && x !== null;
}

export function deepCamelCase(object: any): any {
  if (!isRecord(object)) {
    return object;
  }

  let result = Object.keys(object).reduce<any>((memo, key) => {
    let value = object[key];

    if (isRecord(value)) {
      value = deepCamelCase(value);
    } else if (Array.isArray(value)) {
      value = value.map(deepCamelCase);
    }

    memo[intoCamelCase(key)] = value;
    return memo;
  }, {});

  return result;
}

export function deepSnakeCase(object: any): any {
  if (!isRecord(object)) {
    return object;
  }

  let result = Object.keys(object).reduce<any>((memo, key) => {
    let value = object[key];

    if (isRecord(value)) {
      value = deepSnakeCase(value);
    } else if (Array.isArray(value)) {
      value = value.map(deepSnakeCase);
    }

    memo[intoSnakeCase(key)] = value;
    return memo;
  }, {});

  return result;
}

export function searchQueryString(query: any) {
  return Object.entries(query ?? {})
    .filter(([, value]) => typeof value !== 'undefined')
    .map(([key, value]) => `${intoSnakeCase(key)}=${encodeURIComponent(value as any)}`)
    .join('&');
}

export class NetworkError extends Error {
  status: number;
  res: Response;

  constructor(message: string, status: number, res: Response) {
    super(message);

    this.name = 'NetworkError';
    this.status = status;
    this.res = res;
  }
}
